<section class="section-padding menu-section" id="menu">
  <div class="container">
    <div class="text-center menu-section__header">
      <span class="subtitle">Fresh Daily</span>
      <h2>Our Menu</h2>
      <p class="description">Baked with love, flour, water, and salt. Nothing more, nothing less.</p>
    </div>

    <div class="menu-section__filters text-center">
      @for (category of categories(); track category) {
        <button 
          class="filter-btn" 
          [class.active]="activeCategory() === category"
          (click)="setCategory(category)">
          {{ category }}
        </button>
      }
    </div>

    <div class="menu-section__grid">
      @for (item of filteredItems; track item.id) {
        <div class="menu-card">
          <div class="menu-card__image-wrapper">
            <img [src]="getImgSrc(item.imageUrl)" [alt]="item.name" class="menu-card__image">
          </div>
          <div class="menu-card__content">
            <div class="menu-card__header">
              <h3>{{ item.name }}</h3>
              <span class="price">${{ item.price | number:'1.2-2' }}</span>
            </div>
            <p>{{ item.description }}</p>
          </div>
        </div>
      }
    </div>

    <div class="text-center menu-section__cta">
      <a routerLink="/products" class="btn btn-primary">Shop All Products →</a>
    </div>
  </div>
</section>

